module.exports = __webpack_public_path__ + "static/media/logo-mastercard.73d3a6ed.svg";